import { Component } from '@angular/core';

@Component({
  selector: 'Arrows',
  imports: [],
  template: `
    <svg
      class="inline text-blue-500 w-[30px] h-[30px] md:w-[50px]"
      viewBox="0 0 50 30"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <clipPath id="a"><path d="m1600 0v6060h-1600v-6060z" /></clipPath>
      <g clip-path="url(#a)" transform="translate(-489 -201)">
        <g
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="6"
          transform="translate(494 204)"
        >
          <path d="m12 0-12 12 12 12" />
          <path d="m0 .5h40" transform="translate(0 11.5)" />
          <path d="m0 0 12 12-12 12" transform="translate(28)" />
        </g>
      </g>
    </svg>
  `,
})
export class Arrows {}
